import { useMutation } from "@apollo/client";
import { ClientReadNotificationDocument } from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";
import { getUnreadNotificationCount } from "./useClientUnreadNotificationCountQuery";

export const useReadNotificationMutation = () => {
  const mutation = useMutation(ClientReadNotificationDocument, {
    awaitRefetchQueries: true,
    update: () => {
      const count = getUnreadNotificationCount();
      useAuthState.getState().setUnreadNotificationCount(count - 1);
    },
  });

  return mutation;
};
